module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8wz2C"))).then(() => module.bundle.root('gtEzC'));